import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import rest from 'rest';
import Scroll from 'react-scroll';

import { REST_API_URL, APP_PATH, PERMISSION_READ, PERMISSION_CREATE, PORTAL_URL } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";

import Combobox from '../Helper/Combobox';
import ControlledGrid from '../Helper/ControlledGrid';
import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';
import ModalMessage from '../Helper/ModalMessage';
import Status from '../Helper/Status';
import RemoteRadioGroup from '../Helper/RemoteRadioGroup';
import PermissionCheck from '../Permissions/PermissionCheck';
import AbstractEntity from './AbstractEntity';
import Contact from './Contact';
import DateDeclenchementAlerte from './DateDeclenchementAlerte';
import Document from './Document';
import ListeDiffusion from './ListeDiffusion';

/**
* Class Alerte
* Alerte view component
**/
class Alerte extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    if (this.state.mode === "add") {
      this.state = {
        object: {
          typeAlerte: 0,
          typeDeclenchement: 0
        },
        mode: this.state.mode,
        status: {},
        generatedDates: [],
        modalMessage: {},
      };
    }
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading object if it doesn't exist
  **/
  componentWillMount() {

    if (this.state.object === undefined) {
      const pathName = this.getObjectPath();

      rest({ method: 'GET', path: REST_API_URL + pathName }).then(response => {
        let state = this.state;
        let obj = JSON.parse(response.entity);

        obj.dateDebut = getDateFromString(obj.dateDebut);
        obj.dateFin = getDateFromString(obj.dateFin);

        state.object = obj;

        this.setState(state)
      });
    }
  }

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Alerte";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if (this.state.object === undefined) {
      return <div></div>;
    }

    // Transforms date fields
    let dateDebut = null, dateFin = null;

    if (this.state.object !== undefined) {
      if (this.state.object.dateDebut) {

        dateDebut = this.state.object.dateDebut;

        if (typeof dateDebut === "string") {
          dateDebut = getDateFromString(dateDebut);
        }

        dateDebut = getIsoStringFromDate(dateDebut);
      }

      if (this.state.object.dateFin) {

        dateFin = this.state.object.dateFin;

        if (typeof dateFin === "string") {
          dateFin = getDateFromString(dateFin);
        }

        dateFin = getIsoStringFromDate(dateFin);
      }
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const goBack = <Button bsStyle="link" onClick={this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;
    const minDate = getIsoStringFromDate(new Date());

    const intervalCbxData = this.getIntervalConfig();

    // Modal message
    const modalMessage = <ModalMessage parent={this} {...this.state.modalMessage} />;

    // Bottom bottons
    let bottomButtons = null;
    if (this.state.mode !== "readonly") {
      let buttons =
        <Col smOffset={6} sm={2}>
          <Button bsStyle="success" type="submit">Sauvegarder</Button>
        </Col>;

      if (this.state.mode === "edit" && this.getObjectProperty("typeDeclenchement") === 2) {
        buttons =
          <Col smOffset={6}>
            <Button bsStyle="success" type="submit">Sauvegarder</Button>
            <Button bsStyle="success" onClick={this.launchAlerte.bind(this)}>Lancer l'alerte</Button>
          </Col>;
      }

      bottomButtons = <FormGroup>{buttons}</FormGroup>;
    }

    // Rendering the view
    return (
      <div>
        {/* Status information */}
        {status}
        {goBack}
        {modalMessage}
        <Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire d'alerte.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idAlerte" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idAlerte")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col sm={4}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="typeAlerte">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Type d'alerte</ControlLabel></Col>
            <Col sm={6}><RemoteRadioGroup path="typealertes" refField="typeAlerte" valueField="idTypeAlerte" labelField="libelle"
              onChange={this.handleRadioChange.bind(this)} value={this.getObjectProperty("typeAlerte")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="typeDeclenchement">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Type de déclenchement</ControlLabel></Col>
            <Col sm={6}><RemoteRadioGroup path={(this.props.location.pathname.startsWith(APP_PATH + "/alertes")) ? "typedeclenchements" : "typedeclenchements/limit"} refField="typeDeclenchement" valueField="idTypeDeclenchement" labelField="libelle" onChange={this.handleRadioChange.bind(this)} value={this.getObjectProperty("typeDeclenchement")} disabled={this.state.mode !== "add"} /></Col>
          </FormGroup>

          {/* Type déclenchement planification */}
          {
            (this.state.mode !== "add" && this.getObjectProperty("typeDeclenchement") === 0 && !this.getReadOnly()) ?
              <div className="dateGenerator">
                <FormGroup controlId="dateGenerator">
                  <Col componentClass={ControlLabel} sm={2}>Plannificateur de dates d'alerte</Col>
                  <Col sm={2}>Du :</Col>
                  <Col sm={4}>Tous les :</Col>
                  <Col sm={2}>Au :</Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}></Col>
                  <Col sm={2}><DatePicker ref="dateDebut" dateFormat="DD/MM/YYYY" minDate={minDate} value={dateDebut} onChange={this.handleDateDebutChange} /></Col>
                  <Col sm={2}><FormControl id="valeurFrequence" ref="dateInterval" min={1} type="number" value={this.getObjectProperty("valeurFrequence")} onChange={this.handleChange} /></Col>
                  <Col sm={2}><Combobox ref="dateTypeInterval" dataSource={intervalCbxData} default={this.getObjectProperty("typeFrequence")} onChange={this.handleTypeFrequenceChange.bind(this)}
                    forceSelection={true} /></Col>
                  <Col sm={2}><DatePicker ref="dateFin" dateFormat="DD/MM/YYYY" minDate={dateDebut} value={dateFin} onChange={this.handleDateFinChange} /></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={2}></Col>
                  <Col sm={1}><Button bsStyle="primary" onClick={this.handleGenerateDates.bind(this)}>Générer</Button></Col>
                  <Col sm={1}><Button bsStyle="warning" onClick={this.handleRegenerateDates.bind(this)}>Regénérer</Button></Col>
                  <PermissionCheck component={DateDeclenchementAlerte.getClassName()} permission={PERMISSION_CREATE}>
                    <Col sm={1}>
                      <Link to={APP_PATH + "/alertes/" + this.state.object.idAlerte + "/datedeclenchementalertes/add"}>
                        <Button bsStyle="success" className="gridAddObjectBtn">Ajouter une date unique</Button>
                      </Link>
                    </Col>
                  </PermissionCheck>
                </FormGroup>
              </div> : null
          }
          {
            (this.state.mode !== "add" && this.getObjectProperty("typeDeclenchement") === 0) &&
            <Grid ref="dateDeclenchementGrid" title="Dates de déclenchement" path="datedeclenchementalertes"
              objectPath={"alertes/" + this.state.object.idAlerte + "/datedeclenchementalertes"} objectClass={DateDeclenchementAlerte}
              hiddable={true} hidden={false} mode={this.state.mode} ignoreAdd={true} />
          }

          {/* Type déclenchement déclenchée */}
          {
            (this.getObjectProperty("typeDeclenchement") === 1) ?
              <div>
                <FormGroup controlId="thematique">
                  <Col componentClass={ControlLabel} sm={2}>Thématique</Col>
                  <Col sm={4}><Combobox url={REST_API_URL + "thematiques/"} optionValueKey="idThematique" optionLabelKey="libelle" onChange={this.onThematiqueSelect.bind(this)} placeholder="Choisir une thématique" default={this.getObjectProperty("thematique")} disabled={this.getReadOnly()} /></Col>
                </FormGroup>
                <FormGroup controlId="motCle">
                  <Col componentClass={ControlLabel} sm={2}>Mot-clé</Col>
                  <Col sm={4}><Combobox url={REST_API_URL + "motcles/"} optionValueKey="idMotCle" optionLabelKey="libelle" onChange={this.onMotCleSelect.bind(this)} placeholder="Choisir un mot-clé" default={this.getObjectProperty("motCle")} disabled={this.getReadOnly()} /></Col>
                </FormGroup>
              </div> : null
          }

          {/* ListeDiffusion ManyToMany */}
          <PermissionCheck component={ListeDiffusion.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="listeDiffusions">
              <Col componentClass={ControlLabel} sm={2}>Listes de diffusion</Col>
              <Col sm={6}>
                <ControlledGrid ref="listeDiffusionsGrid" path="listediffusions" objectPath={"alertes_listediffusions/" + this.state.object.idAlerte + "/listediffusions"} objectClass={ListeDiffusion} mode={this.state.mode} cbxUrl={REST_API_URL + "alertes_listediffusions/" + this.state.object.idAlerte + "/listediffusions/inverse/"} optionValueKey="idListeDiffusion" optionLabelKey="libelle" disableAdd={true} />
              </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Contact ManyToMany */}
          <PermissionCheck component={Contact.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="contacts">
              <Col componentClass={ControlLabel} sm={2}>Contacts</Col>
              <Col sm={6}>
                <ControlledGrid ref="contactsGrid" path="contacts" objectPath={"alertes_contacts/" + this.state.object.idAlerte + "/contacts"} objectClass={Contact} mode={this.state.mode} cbxUrl={REST_API_URL + "alertes_contacts/" + this.state.object.idAlerte + "/contacts/inverse/"} cbxParams="?interne=true" optionValueKey="idContact" optionLabelKey="fullName" />
              </Col>
            </FormGroup>
          </PermissionCheck>

          <FormGroup controlId="objet">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Objet</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={4}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("objet")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="corpsTexte">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Texte du message</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("corpsTexte")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"alertes/" + this.getObjectProperty("idAlerte") + "/documents"} objectClass={Document} mode={this.state.mode} hiddable={true} />
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {this.state.mode !== "add" &&
            <GeometryGrid title="Géométries" path="alertes_geoms" objectPath={"alertes_geoms/" + this.getObjectProperty("idAlerte")} objectClass={Alerte} mode={this.state.mode}
              queryLayers="AlerteCreate" allowDraw={false} selectionMultiple={true} typeGeometry="all" withImportCsv={false} withImportPoint={false} />
          }

          {/* Bottom buttons */}
          {bottomButtons}

        </Form>
      </div>
    );
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idAlerte";
  }

  /**
  * onThematiqueSelect
  * Modify the state thematique property from thematique Combobox change
  **/
  onThematiqueSelect(thematique) {
    let objState = this.state;
    objState.object["thematique"] = thematique.idThematique;
    this.setState(objState);
  }

  /**
  * onMotCleSelect
  * Modify the state motcle property from motcle Combobox change
  **/
  onMotCleSelect(motCle) {
    let objState = this.state;
    objState.object["motCle"] = motCle.idMotCle;
    this.setState(objState);
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData(immediate) {

    // console.log('sendFormData');
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let alerteObj = cloneObject(this.state.object);

    if (this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if (this.refs.contactsGrid !== undefined) alerteObj.contacts = this.refs.contactsGrid.getArrayToSave();
      if (this.refs.listeDiffusionsGrid !== undefined) alerteObj.listeDiffusions = this.refs.listeDiffusionsGrid.getArrayToSave();
    }








    // console.log(alerteObj.contacts)
    // Validation des champs mails
    if (alerteObj.contacts.length == 0 && alerteObj.listeDiffusions.length == 0 && this.state.mode === "add") {
      this.setState({
        status: {
          type: 'danger',
          message: 'Il n\'y a aucun destinataire.'
        }
      });

      return;
    }

    // console.log('contact');
    // console.log(alerteObj);
    //
    // if(alerteObj.contacts.length==0 && alerteObj.listeDiffusions.length==0 && this.state.mode === "edit") {
    //   this.setState({
    //     status: {
    //       type: 'danger',
    //       message: 'Il n\'y a aucun destinataire.'
    //     }
    //     });
    //
    //   return;
    // }


    if (typeof alerteObj.dateDebut !== "string") {
      alerteObj.dateDebut = getStringFromDate(alerteObj.dateDebut);
    }

    if (typeof alerteObj.dateFin !== "string") {
      alerteObj.dateFin = getStringFromDate(alerteObj.dateFin);
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });


    rest({ method: 'GET', path: REST_API_URL + 'users/' }).then(response => {

      //UPDATE LIVRAISON
      const user = JSON.parse(response.entity);                          
      //const user = JSON.parse("{\"uid\":\"tboisteux\",\"password\":\"{SHA}2HXzqJRMIEP/IImiFj9xmNIloys=\",\"displayName\":\"Tony Boisteux\",\"mail\":\"t.boisteux@memoris.fr\",\"roles\":[\"Administrateur\"],\"permissions\":[{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":1,\"apiPath\":\"/alertes\",\"className\":\"Alerte\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":1,\"apiPath\":\"/alertes\",\"className\":\"Alerte\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":1,\"apiPath\":\"/alertes\",\"className\":\"Alerte\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":1,\"apiPath\":\"/alertes\",\"className\":\"Alerte\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":2,\"apiPath\":\"/auteurs\",\"className\":\"Auteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":2,\"apiPath\":\"/auteurs\",\"className\":\"Auteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":2,\"apiPath\":\"/auteurs\",\"className\":\"Auteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":2,\"apiPath\":\"/auteurs\",\"className\":\"Auteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":3,\"apiPath\":\"/cautions\",\"className\":\"Caution\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":3,\"apiPath\":\"/cautions\",\"className\":\"Caution\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":3,\"apiPath\":\"/cautions\",\"className\":\"Caution\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":3,\"apiPath\":\"/cautions\",\"className\":\"Caution\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":4,\"apiPath\":\"/clients\",\"className\":\"Client\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":4,\"apiPath\":\"/clients\",\"className\":\"Client\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":4,\"apiPath\":\"/clients\",\"className\":\"Client\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":4,\"apiPath\":\"/clients\",\"className\":\"Client\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":5,\"apiPath\":\"/contacts\",\"className\":\"Contact\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":5,\"apiPath\":\"/contacts\",\"className\":\"Contact\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":5,\"apiPath\":\"/contacts\",\"className\":\"Contact\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":5,\"apiPath\":\"/contacts\",\"className\":\"Contact\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":5,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":5,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":5,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":5,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":6,\"apiPath\":\"/contrats\",\"className\":\"Contrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":6,\"apiPath\":\"/contrats\",\"className\":\"Contrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":6,\"apiPath\":\"/contrats\",\"className\":\"Contrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":6,\"apiPath\":\"/contrats\",\"className\":\"Contrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":7,\"apiPath\":\"/documents\",\"className\":\"Document\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":7,\"apiPath\":\"/documents\",\"className\":\"Document\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":7,\"apiPath\":\"/documents\",\"className\":\"Document\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":7,\"apiPath\":\"/documents\",\"className\":\"Document\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":8,\"apiPath\":\"/donneurordres\",\"className\":\"DonneurOrdre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":8,\"apiPath\":\"/donneurordres\",\"className\":\"DonneurOrdre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":8,\"apiPath\":\"/donneurordres\",\"className\":\"DonneurOrdre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":8,\"apiPath\":\"/donneurordres\",\"className\":\"DonneurOrdre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":9,\"apiPath\":\"/echanges\",\"className\":\"Echange\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":9,\"apiPath\":\"/echanges\",\"className\":\"Echange\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":9,\"apiPath\":\"/echanges\",\"className\":\"Echange\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":9,\"apiPath\":\"/echanges\",\"className\":\"Echange\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":10,\"apiPath\":\"/elementcontrats\",\"className\":\"ElementContrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":10,\"apiPath\":\"/elementcontrats\",\"className\":\"ElementContrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":10,\"apiPath\":\"/elementcontrats\",\"className\":\"ElementContrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":10,\"apiPath\":\"/elementcontrats\",\"className\":\"ElementContrat\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":11,\"apiPath\":\"/elementprojets\",\"className\":\"ElementProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":11,\"apiPath\":\"/elementprojets\",\"className\":\"ElementProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":11,\"apiPath\":\"/elementprojets\",\"className\":\"ElementProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":11,\"apiPath\":\"/elementprojets\",\"className\":\"ElementProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":12,\"apiPath\":\"/etatdeslieux\",\"className\":\"EtatDesLieux\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":12,\"apiPath\":\"/etatdeslieux\",\"className\":\"EtatDesLieux\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":12,\"apiPath\":\"/etatdeslieux\",\"className\":\"EtatDesLieux\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":12,\"apiPath\":\"/etatdeslieux\",\"className\":\"EtatDesLieux\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":13,\"apiPath\":\"/evenements\",\"className\":\"Evenement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":13,\"apiPath\":\"/evenements\",\"className\":\"Evenement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":13,\"apiPath\":\"/evenements\",\"className\":\"Evenement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":13,\"apiPath\":\"/evenements\",\"className\":\"Evenement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":14,\"apiPath\":\"/facturationencaissements\",\"className\":\"FacturationEncaissement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":14,\"apiPath\":\"/facturationencaissements\",\"className\":\"FacturationEncaissement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":14,\"apiPath\":\"/facturationencaissements\",\"className\":\"FacturationEncaissement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":14,\"apiPath\":\"/facturationencaissements\",\"className\":\"FacturationEncaissement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":15,\"apiPath\":\"/financeurs\",\"className\":\"Financeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":15,\"apiPath\":\"/financeurs\",\"className\":\"Financeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":15,\"apiPath\":\"/financeurs\",\"className\":\"Financeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":15,\"apiPath\":\"/financeurs\",\"className\":\"Financeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":16,\"apiPath\":\"/listediffusions\",\"className\":\"ListeDiffusion\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":16,\"apiPath\":\"/listediffusions\",\"className\":\"ListeDiffusion\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":16,\"apiPath\":\"/listediffusions\",\"className\":\"ListeDiffusion\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":16,\"apiPath\":\"/listediffusions\",\"className\":\"ListeDiffusion\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":17,\"apiPath\":\"/motcles\",\"className\":\"MotCle\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":17,\"apiPath\":\"/motcles\",\"className\":\"MotCle\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":17,\"apiPath\":\"/motcles\",\"className\":\"MotCle\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":17,\"apiPath\":\"/motcles\",\"className\":\"MotCle\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":18,\"apiPath\":\"/objectifs\",\"className\":\"Objectif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":18,\"apiPath\":\"/objectifs\",\"className\":\"Objectif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":18,\"apiPath\":\"/objectifs\",\"className\":\"Objectif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":18,\"apiPath\":\"/objectifs\",\"className\":\"Objectif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":19,\"apiPath\":\"/observations\",\"className\":\"Observation\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":19,\"apiPath\":\"/observations\",\"className\":\"Observation\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":19,\"apiPath\":\"/observations\",\"className\":\"Observation\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":19,\"apiPath\":\"/observations\",\"className\":\"Observation\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":20,\"apiPath\":\"/permissions\",\"className\":\"Permission\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":20,\"apiPath\":\"/permissions\",\"className\":\"Permission\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":20,\"apiPath\":\"/permissions\",\"className\":\"Permission\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":20,\"apiPath\":\"/permissions\",\"className\":\"Permission\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":21,\"apiPath\":\"/prestataires\",\"className\":\"Prestataire\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":21,\"apiPath\":\"/prestataires\",\"className\":\"Prestataire\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":21,\"apiPath\":\"/prestataires\",\"className\":\"Prestataire\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":21,\"apiPath\":\"/prestataires\",\"className\":\"Prestataire\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":22,\"apiPath\":\"/projets\",\"className\":\"Projet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":22,\"apiPath\":\"/projets\",\"className\":\"Projet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":22,\"apiPath\":\"/projets\",\"className\":\"Projet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":22,\"apiPath\":\"/projets\",\"className\":\"Projet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":23,\"apiPath\":\"/responsables\",\"className\":\"Responsable\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":23,\"apiPath\":\"/responsables\",\"className\":\"Responsable\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":23,\"apiPath\":\"/responsables\",\"className\":\"Responsable\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":23,\"apiPath\":\"/responsables\",\"className\":\"Responsable\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":24,\"apiPath\":\"/stations\",\"className\":\"Station\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":24,\"apiPath\":\"/stations\",\"className\":\"Station\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":24,\"apiPath\":\"/stations\",\"className\":\"Station\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":24,\"apiPath\":\"/stations\",\"className\":\"Station\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":25,\"apiPath\":\"/tarifs\",\"className\":\"Tarif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":25,\"apiPath\":\"/tarifs\",\"className\":\"Tarif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":25,\"apiPath\":\"/tarifs\",\"className\":\"Tarif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":25,\"apiPath\":\"/tarifs\",\"className\":\"Tarif\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":26,\"apiPath\":\"/tarifications\",\"className\":\"Tarification\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":26,\"apiPath\":\"/tarifications\",\"className\":\"Tarification\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":26,\"apiPath\":\"/tarifications\",\"className\":\"Tarification\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":26,\"apiPath\":\"/tarifications\",\"className\":\"Tarification\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":27,\"apiPath\":\"/taxefoncieres\",\"className\":\"TaxeFonciere\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":27,\"apiPath\":\"/taxefoncieres\",\"className\":\"TaxeFonciere\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":27,\"apiPath\":\"/taxefoncieres\",\"className\":\"TaxeFonciere\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":27,\"apiPath\":\"/taxefoncieres\",\"className\":\"TaxeFonciere\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":28,\"apiPath\":\"/thematiques\",\"className\":\"Thematique\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":28,\"apiPath\":\"/thematiques\",\"className\":\"Thematique\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":28,\"apiPath\":\"/thematiques\",\"className\":\"Thematique\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":28,\"apiPath\":\"/thematiques\",\"className\":\"Thematique\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":29,\"apiPath\":\"/typedocuments\",\"className\":\"TypeDocument\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":29,\"apiPath\":\"/typedocuments\",\"className\":\"TypeDocument\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":29,\"apiPath\":\"/typedocuments\",\"className\":\"TypeDocument\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":29,\"apiPath\":\"/typedocuments\",\"className\":\"TypeDocument\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":30,\"apiPath\":\"/valeurs\",\"className\":\"Valeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":30,\"apiPath\":\"/valeurs\",\"className\":\"Valeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":30,\"apiPath\":\"/valeurs\",\"className\":\"Valeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":30,\"apiPath\":\"/valeurs\",\"className\":\"Valeur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":31,\"apiPath\":\"/requetes\",\"className\":\"Requete\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":31,\"apiPath\":\"/requetes\",\"className\":\"Requete\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":31,\"apiPath\":\"/requetes\",\"className\":\"Requete\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":31,\"apiPath\":\"/requetes\",\"className\":\"Requete\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":32,\"apiPath\":\"/requetesDomaine\",\"className\":\"RequeteDomaine\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":32,\"apiPath\":\"/requetesDomaine\",\"className\":\"RequeteDomaine\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":32,\"apiPath\":\"/requetesDomaine\",\"className\":\"RequeteDomaine\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":32,\"apiPath\":\"/requetesDomaine\",\"className\":\"RequeteDomaine\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":33,\"apiPath\":\"/uniteprojets\",\"className\":\"UniteProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":33,\"apiPath\":\"/uniteprojets\",\"className\":\"UniteProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":33,\"apiPath\":\"/uniteprojets\",\"className\":\"UniteProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":33,\"apiPath\":\"/uniteprojets\",\"className\":\"UniteProjet\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":34,\"apiPath\":\"/balises\",\"className\":\"Balise\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":34,\"apiPath\":\"/balises\",\"className\":\"Balise\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":34,\"apiPath\":\"/balises\",\"className\":\"Balise\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":34,\"apiPath\":\"/balises\",\"className\":\"Balise\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":35,\"apiPath\":\"/capteurs\",\"className\":\"Capteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":35,\"apiPath\":\"/capteurs\",\"className\":\"Capteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":35,\"apiPath\":\"/capteurs\",\"className\":\"Capteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":35,\"apiPath\":\"/capteurs\",\"className\":\"Capteur\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":36,\"apiPath\":\"/capteurParametres\",\"className\":\"CapteurParametre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":36,\"apiPath\":\"/capteurParametres\",\"className\":\"CapteurParametre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":36,\"apiPath\":\"/capteurParametres\",\"className\":\"CapteurParametre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":36,\"apiPath\":\"/capteurParametres\",\"className\":\"CapteurParametre\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":37,\"apiPath\":\"/requetesDomaineRGPD\",\"className\":\"RequeteDomaineRGPD\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":37,\"apiPath\":\"/requetesDomaineRGPD\",\"className\":\"RequeteDomaineRGPD\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":37,\"apiPath\":\"/requetesDomaineRGPD\",\"className\":\"RequeteDomaineRGPD\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":37,\"apiPath\":\"/requetesDomaineRGPD\",\"className\":\"RequeteDomaineRGPD\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":38,\"apiPath\":\"/contactsArchive\",\"className\":\"ContactsArchive\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":38,\"apiPath\":\"/contactsArchive\",\"className\":\"ContactsArchive\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":38,\"apiPath\":\"/contactsArchive\",\"className\":\"ContactsArchive\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":38,\"apiPath\":\"/contactsArchive\",\"className\":\"ContactsArchive\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":39,\"apiPath\":\"/contactsInterne\",\"className\":\"ContactsInterne\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":39,\"apiPath\":\"/contactsInterne\",\"className\":\"ContactsInterne\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":39,\"apiPath\":\"/contactsInterne\",\"className\":\"ContactsInterne\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":39,\"apiPath\":\"/contactsInterne\",\"className\":\"ContactsInterne\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":1,\"type\":\"read\",\"libelle\":\"Afficher\"},\"composant\":{\"id\":40,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":2,\"type\":\"create\",\"libelle\":\"Ajouter\"},\"composant\":{\"id\":40,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":3,\"type\":\"update\",\"libelle\":\"Modifier\"},\"composant\":{\"id\":40,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true},{\"idLdapGroup\":1,\"droit\":{\"id\":4,\"type\":\"delete\",\"libelle\":\"Supprimer\"},\"composant\":{\"id\":40,\"apiPath\":\"/contactsEnvironnement\",\"className\":\"ContactsEnvironnement\"},\"hasRight\":true}],\"loggedIn\":true}");

      // No user => redirect to portail connection
      if (!user.uid || !user.loggedIn) {
        window.location.href = PORTAL_URL + 'login/fr/signin/?next=';
      } else { // User => load user info

        if (this.state.mode === "add") {
          alerteObj.libelleUtilisateur = user.displayName.replace('.','-');
        }

        console.log(alerteObj);
        rest({
          method: method,
          path: path,
          entity: JSON.stringify(alerteObj),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.status.code === 200) {
            this.saveGrids();
            this.setState({
              status: {
                type: 'success',
                message: 'Alerte sauvegardé.'
              },
              object: JSON.parse(response.entity)
            });

            if (immediate === true) {
              rest({
                method: "GET",
                path: path + "/immediate"
              }).then(response => {
                this.setState({
                  status: {
                    type: 'success',
                    message: 'Alerte générée.'
                  }
                });
              });
            }
          } else if (response.status.code === 201) {
            const newObj = JSON.parse(response.entity);

            const state = {
              status: {
                type: 'success',
                message: 'Alerte créé.'
              },
              mode: 'edit',
              object: newObj
            };

            this.replaceHistory(APP_PATH + "/alertes/" + newObj[this.getIdField()] + "/edit", state);

            if (this.props.onAdd) {
              this.props.onAdd.call(this, newObj);
            }
          } else {
            this.setState({
              status: {
                type: 'danger',
                message: 'Erreur de sauvegarde.'
              }
            });
          }
        }, response => {
          this.setState({
            status: {
              type: 'danger',
              message: 'Problème d\'appel au serveur.'
            }
          });
        });



      }
    });


    console.log(alerteObj);
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if (this.refs.listeDiffusionsGrid !== undefined) this.refs.listeDiffusionsGrid.saveAll();
    if (this.refs.contactsGrid !== undefined) this.refs.contactsGrid.saveAll();
  }

  /**
  * getIntervalConfig
  * Returns the interval Combobox configuration
  **/
  getIntervalConfig() {
    return {
      collection: [{
        id: "Jour",
        name: "Jour"
      }, {
        id: "Semaine",
        name: "Semaine"
      }, {
        id: "Mois",
        name: "Mois"
      }, {
        id: "Annee",
        name: "Année"
      }]
    };
  }

  /**
  * handleGenerateDates
  * Handle generate dates button click
  **/
  handleGenerateDates() {
    this.generateDates(false);
  }

  /**
  * handleRegenerateDates
  * Handle regenerate dates button click
  **/
  handleRegenerateDates() {
    this.generateDates(true);
  }

  /**
  * handleTypeFrequenceChange
  * Update typeFrequence value
  **/
  handleTypeFrequenceChange(value) {
    let state = this.state;
    state.object.typeFrequence = value.id;
    this.setState(state);
  }

  /**
  * generateDates
  * Launch date (re)generation
  **/
  generateDates(replace) {
    let state = this.state;

    const dateDebutStr = this.refs.dateDebut.getValue();
    if (!dateDebutStr) {
      state.status = {
        type: 'danger',
        message: 'La date de début est obligatoire.'
      };
      this.setState(state);
      return;
    }
    const dateDebut = new Date(dateDebutStr);
    const dateInterval = parseInt(this.getObjectProperty("valeurFrequence"), 10);

    if (dateInterval === undefined) {
      state.status = {
        type: 'danger',
        message: 'L\'intervalle est obligatoire.'
      };
      this.setState(state);
      return;
    }

    const dateTypeInterval = this.getObjectProperty("typeFrequence");
    if (dateTypeInterval === undefined) {
      state.status = {
        type: 'danger',
        message: 'Le type d\'intervalle est obligatoire.'
      };
      this.setState(state);
      return;
    }

    const dateFinStr = this.refs.dateFin.getValue();
    if (!dateFinStr) {
      state.status = {
        type: 'danger',
        message: 'La date de fin est obligatoire.'
      };
      this.setState(state);
      return;
    }
    const dateFin = new Date(dateFinStr);

    let generatedDates = [];
    let currentDate = dateDebut;

    while (currentDate <= dateFin) {
      generatedDates.push({ dateDeclenchement: getStringFromDate(currentDate) });

      switch (dateTypeInterval) {
        case "Jour":
          currentDate.setDate(currentDate.getDate() + dateInterval);
          break;
        case "Semaine":
          currentDate.setDate(currentDate.getDate() + dateInterval * 7);
          break;
        case "Mois":
          currentDate.setMonth(currentDate.getMonth() + dateInterval);
          break;
        case "Annee":
          currentDate.setFullYear(currentDate.getFullYear() + dateInterval);
          break;
        default:
          console.log("Invalid date intervalle type");
          break;
      }
    }

    state.generatedDates = generatedDates;
    state.replace = replace;
    state.modalMessage = {
      parent: this,
      style: "warning",
      title: "Génération automatique",
      message: <div><p>{generatedDates.length} dates d'alerte ont été générées.</p><p><b>Continuer ?</b></p></div>,
      onlyOk: false,
      handleOk: this.handleModal.bind(this),
      handleCancel: this.handleModal.bind(this),
      visible: true
    };

    this.setState(state);
  }

  /**
  * handleModal
  * Launch date creation on server
  **/
  handleModal(ok) {
    let state = this.state;

    if (ok) {
      let pathName = this.getObjectPath();
      pathName = (this.state.replace === true) ? pathName + "/datedeclenchementalertes/replace" : pathName + "/datedeclenchementalertes/save";
      rest({
        method: 'POST',
        path: REST_API_URL + pathName,
        entity: JSON.stringify(state.generatedDates),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {

        state.modalMessage = {};
        state.generatedDates = [];

        if (response.status.code === 201) {
          state.status = {
            type: 'success',
            message: 'Dates d\'alerte sauvegardées avec succès.'
          };

          this.refs.dateDeclenchementGrid.reload();
        } else {
          state.status = {
            type: 'danger',
            message: 'Erreur lors de la sauvegarde des dates d\'alerte.'
          };
        }

        this.setState(state);
      });
    } else {
      state.modalMessage = {};
      state.generatedDates = [];
      this.setState(state);
    }
  }

  /**
  * launchAlerte
  * Launch immediate Alerte
  **/
  launchAlerte() {
    this.sendFormData(true);
  }

}

export default Alerte;



// WEBPACK FOOTER //
// ./src/views/Entity/Alerte.js